export default __webpack_public_path__ + "static/poster-workspace-e98c40093f32ec5adfc5076544a5bfaf.jpg";